import { Card } from "@/components/ui/card";
import StatusBadge from "./StatusBadge";
import { FileText, Calendar, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { format } from "date-fns";
import { useTranslation } from 'react-i18next';

export default function ApplicationCard({ application, onClick }) {
  const { t } = useTranslation();
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ y: -4 }}
      data-testid={`application-card-${application.id}`}
    >
      <Card
        onClick={onClick}
        className="bg-white border border-stone-200 shadow-sm hover:shadow-md hover:border-emerald-500/50 p-6 cursor-pointer transition-all relative overflow-hidden rounded-xl"
      >
        <div className="absolute inset-0 opacity-50 mix-blend-multiply pointer-events-none bg-[url('https://grainy-gradients.vercel.app/noise.svg')]"></div>
        
        <div className="relative z-10">
          <div className="flex justify-between items-start mb-4">
            <div className="flex-1">
              <h3 className="text-lg font-manrope font-bold text-slate-900 tracking-tight mb-1">
                {application.purpose}
              </h3>
              <p className="text-xs font-mono text-slate-500">
                #{application.land_survey_number}
              </p>
            </div>
            <StatusBadge status={application.status} />
          </div>

          <div className="space-y-2">
            <div className="flex items-center text-sm text-slate-600">
              <MapPin className="w-4 h-4 mr-2 text-emerald-700" />
              <span>{application.village}, {application.district}</span>
            </div>
            <div className="flex items-center text-sm text-slate-600">
              <FileText className="w-4 h-4 mr-2 text-emerald-700" />
              <span>{application.land_area} {t('application.acres')}</span>
            </div>
            <div className="flex items-center text-sm text-slate-500">
              <Calendar className="w-4 h-4 mr-2" />
              <span>{format(new Date(application.created_at), "MMM dd, yyyy")}</span>
            </div>
          </div>
        </div>
      </Card>
    </motion.div>
  );
}